import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash-es';
import { routesForLanguage } from '../routes/routes';
import DataContext from './DataContext/DataContext';

const ContainerStyle = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  box-shadow: 1px 1px 3px;
  padding: 20px;
  margin-top: 20px;
`;

function getErrorMessage(error = {}) {
  if (error.response) {
    return get(error, 'response.data.message');
  }
  if (error.message) {
    return error.message;
  }
  return '';
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    const { location } = this.props;

    // Optional logic if "error" route exists
    if (location.pathname.includes("error")) {
      this.setState({ hasError: true, error: new Error("Page not found") });
    }
  }

  goToStartPage = (e, org, lang) => {
     let userRole = "";
     const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    userRole = userDetails && userDetails.role ? userDetails.role : "";
     const redirectUrl = localStorage.getItem("redirectAfterLogin");
    
     if (userRole === "MARKET") {
    e.preventDefault();
     window.location.href=redirectUrl;
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("userDetails");
    //   localStorage.removeItem("interactionData");
    //   localStorage.removeItem("previousMarket");
    //   localStorage.removeItem("salesArea");
    //   localStorage.removeItem("selectedMarketLang");
    //   localStorage.removeItem("store");
    //   localStorage.removeItem("uniqueID");
    //   localStorage.removeItem("redirectAfterLogin");
    //   localStorage.removeItem("tokenGeneratedAt");
    //   localStorage.removeItem("tokenExpiresIn");

    // window.location.href = routesForLanguage(org, lang).startPageRoute();
     }{
      e.preventDefault();
      window.location.href = "/global"
     }
  };

  renderError() {
    const { location } = this.props;
    const { error } = this.state;
    const errorMessage = getErrorMessage(error);

    return (
      <DataContext.Consumer>
        {({ org, lang }) => (
          <ContainerStyle>
            <h1>Oops! An error occurred...</h1>
            <p>{errorMessage}</p>
            <p>{location.pathname}</p>
            <a
              style={{ cursor: "pointer", color: "#00b0ff", fontWeight: "bold" }}
              onClick={(e) => this.goToStartPage(e, org, lang)}
            >
              Go to start page
            </a>
          </ContainerStyle>
        )}
      </DataContext.Consumer>
    );
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return this.renderError();
    }
    return children;
  }
}

export default ErrorBoundary;
